import { ShareArea } from '@/modules/copay/components/dialogShareCopay/shareArea';
import { TextSuccess } from '@/modules/copay/components/dialogShareCopay/textSuccess';
import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { Dialog } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface DialogShareCopayProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  usageStatementId?: string;
}

export const DialogShareCopay: React.FC<DialogShareCopayProps> = ({
  open,
  setOpen,
  usageStatementId,
}) => {
  const useRefDialog = useRef({ open: () => {}, dismiss: () => {} });

  useEffect(() => {
    open ? useRefDialog.current.open() : useRefDialog.current.dismiss();
  }, [open]);

  return (
    <Dialog
      shadow
      outlined
      rounded
      instanceEmitter={useRefDialog.current}
      elevation={2}
      size={1000}
      body={
        <Grid padding={30} gap={64}>
          <TextSuccess setOpen={setOpen} />
          <div style={{ minWidth: 500 }}>
            <ShareArea usageStatementId={usageStatementId} />
          </div>
        </Grid>
      }
    />
  );
};
